import { render, staticRenderFns } from "./producto.filtro.categoria.vue?vue&type=template&id=0d8165a8&scoped=true&"
import script from "./producto.filtro.categoria.vue?vue&type=script&lang=js&"
export * from "./producto.filtro.categoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8165a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VListItem,VListItemContent,VListItemTitle,VProgressCircular})
